import {AxiosError} from "axios";

export enum HttpStatus {
    OK = 200,
    BAD_REQUEST = 400,
    CONFLICT = 409,
    INTERNAL_SERVER_ERROR = 500,
}

export class ApiError {
    public static fromAxios(error: { response: { status: number, data: string } }): ApiError {
        if (!error.response) {
            return  new ApiError(HttpStatus.INTERNAL_SERVER_ERROR, "Internal server error");
        }
        const response = error.response;
        const message = response.data;

        return new ApiError(error.response.status, (message ? message : undefined));
    }

    public static fromAxiosWithBody(error: AxiosError): ApiError {
        if (!error.response) {
            return new ApiError(HttpStatus.INTERNAL_SERVER_ERROR, "Internal server error");
        }

        if (error.response!.data || (!error.response!.data as any).error) {
            return this.fromAxios(error as any);
        }

        return new ApiError(error.response!.status, (error.response!.data as any)?.error);
    }

    constructor(public errorNumber: number,
                public message?: string) {
    }
}
